module.exports = __webpack_public_path__ + "assets/img/ig-4.30fa51f4.png";